import {getSupportedLanguages} from '@hconnect/common/utils'
import {useMemo} from 'react'
import {useTranslation} from 'react-i18next'

export const useSupportedLanguages = () => {
  const {i18n} = useTranslation()

  return useMemo(() => getSupportedLanguages(i18n), [i18n])
}
